






























































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Customer from "@/api/Customer";
import CustomerService from "@/service/CustomerService";
import RenderModal from "@/components/Shared/RenderModal.vue";
import CustomerImage from "@/api/Customer/CustomerImage";

@Component({
  components: {RenderModal}
})
export default class CustomerImageEditFormView extends Vue {
  @Prop() private customer!: Customer;
  private uploadFieldVisible = false;
  private customerImage = new CustomerImage();
  private uploadedImage: any = false;

  mounted() {
    if (this.customer) {
      this.customerImage = new CustomerImage(this.customer);
      this.uploadFieldVisible = !this.customer.hasCustomImage;
    }
  }

  closeForm(saved = false) {
    this.$emit('close-customer-info-form', {saved: saved});
  }

  async uploadFile() {
    if (this.uploadedImage) {
      try {
        const response = await CustomerService.uploadCustomerImage(this.uploadedImage.fileList[0]);
        if (response.success) {
          this.uploadFieldVisible = false;
          this.customerImage.hasCustomImage = true;
          this.customerImage.imageVerified = false;
          this.closeForm(true);
        } else {
          alert(response.message);
        }
      } catch (err) {
        alert('Error uploading')
        console.error(err)
      }
    }

  }

  async deleteImage() {
    if (confirm("آیا اطمینان دارید که می‌خواید تصویر خود را حذف کنید؟")) {
      const response = await CustomerService.deleteCustomerImage();
      if (response.success) {
        this.closeForm(true);
      } else {
        alert(response.message);
      }
    }
  }

  async saveCustomerImage() {
    this.closeForm(true);
  }

  async toggleUploadField() {
    this.uploadFieldVisible = !this.uploadFieldVisible;
  }
}
